"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestIsEditable = exports.requestNoteSchema = exports.REQUEST_PRECISIONS_QUIET_MINUTES = exports.SHARED_DOCUMENTS_COMMERCIAL_MAX = exports.REQUEST_NOTE_MAX_LENGTH = void 0;
const zod_1 = require("zod");
const index_1 = require("../project/index");
/**
 * #791 — The commercial's request on an urban study, and the study's shared
 * documents.
 *
 * The commercial side (SALESMAN or their company) leaves ONE note for the
 * architect — the question behind the study, the site context the cadastre does
 * not show — and both sides share photos and PDFs on the study. The note is
 * `urban_analysis.request_note`, distinct from `comment`, which is the
 * architect's and is rewritten at every validation or refusal.
 *
 * These limits are read by the backend (create and update boundaries, upload
 * ticket) and by the frontend (counter, upload list), so the two cannot drift.
 */
exports.REQUEST_NOTE_MAX_LENGTH = 2000;
/** The commercial side adds while the study holds fewer shared documents than
 *  this, whoever added them. The architect's office is not held to it. */
exports.SHARED_DOCUMENTS_COMMERCIAL_MAX = 10;
/** Commercial changes quiet for this long are mailed to the architect as one
 *  e-mail; the same window after the request belongs to the request itself. */
exports.REQUEST_PRECISIONS_QUIET_MINUTES = 10;
/** The note as stored: trimmed, and a blank one is no note at all. */
exports.requestNoteSchema = zod_1.z
    .string()
    .trim()
    .max(exports.REQUEST_NOTE_MAX_LENGTH)
    .nullish()
    .transform((value) => (value ? value : null));
/**
 * Whether the commercial side may still change its request. A validated study is
 * delivered; a cancelled one is terminal. A study sent back for modification
 * stays open — that is when the architect most needs the context.
 */
const requestIsEditable = (status) => status !== index_1.FormStatus.VALIDATED && status !== index_1.FormStatus.CANCELLED;
exports.requestIsEditable = requestIsEditable;
//# sourceMappingURL=studyRequest.js.map